var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBridgeIcLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8762 21C18.7482 21 17.7732 20.6111 17.2512 20.3535C16.7292 20.6111 15.7542 21 14.6262 21C13.4982 21 12.5232 20.6111 12.0012 20.3535C11.4792 20.6111 10.5042 21 9.37616 21C8.24816 21 7.27316 20.6111 6.75116 20.3535C6.22916 20.6111 5.25416 21 4.12616 21C2.47653 21 1.15316 20.1675 1.09766 20.1322L1.90241 18.8666C1.91253 18.8726 2.92578 19.5 4.12616 19.5C5.32353 19.5 6.33753 18.8741 6.34766 18.8677L6.75116 18.6101L7.15466 18.8681C7.16253 18.8726 8.17578 19.5 9.37616 19.5C10.5735 19.5 11.5875 18.8741 11.5977 18.8677L12.0012 18.6101L12.4047 18.8681C12.4125 18.8726 13.4258 19.5 14.6262 19.5C15.8235 19.5 16.8375 18.8741 16.8477 18.8677L17.2512 18.6101L17.6547 18.8681C17.6625 18.8726 18.6758 19.5 19.8762 19.5C21.0735 19.5 22.0875 18.8741 22.0977 18.8677L22.9047 20.1319C22.8492 20.1675 21.5258 21 19.8762 21Z",
    fill: "#F2AE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3V6.75C3.36412 6.75 4.875 8.26087 4.875 10.125V13.875H4.125V18.375C5.61412 18.375 6.75 17.2751 6.75 17.2751C6.75 17.2751 7.872 18.375 9.375 18.375V13.875H8.625V10.125C8.625 8.26087 10.1359 6.75 12 6.75C13.8641 6.75 15.375 8.26087 15.375 10.125V13.875H14.625V18.375C16.128 18.375 17.25 17.2751 17.25 17.2751C17.25 17.2751 18.3859 18.375 19.875 18.375V13.875H19.125V10.125C19.125 8.26087 20.6359 6.75 22.5 6.75V3H1.5ZM7.5 6.75H6V4.875H7.5V6.75ZM18 6.75H16.5V4.875H18V6.75Z",
    fill: "#02B37F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridgeIcLight);
export default __webpack_public_path__ + "static/media/bridge_ic_light.d6f3c45d8e50ea22918b963ca5e30406.svg";
export { ForwardRef as ReactComponent };